export const SEARCH_DEBOUNCE_MS = 300;

export const HEARING_DATE_PRESETS = [
  { label: 'Today', value: 'today' },
  { label: 'Week', value: 'week' },
  { label: 'Month', value: 'month' },
] as const;

export type HearingDatePreset = (typeof HEARING_DATE_PRESETS)[number]['value'];

export const DEFAULT_HEARING_DATE_PRESET: HearingDatePreset = 'week';

// Filters map to the hearing's server-computed derivedStatus (the outcome shown
// in the table), except `missed` which is a server-side pseudo-status (an
// accepted attempt whose call never happened, in the past).
export const HEARING_STATUS_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Pending', value: 'pending' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Approved', value: 'approved' },
  { label: 'Not Yet', value: 'notYet' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Missed', value: 'missed' },
] as const;

export type HearingStatusFilter =
  | ''
  | 'pending'
  | 'accepted'
  | 'approved'
  | 'notYet'
  | 'cancelled'
  | 'missed';

export const SEARCH_MODE_OPTIONS = [
  { label: 'Student', value: 'student' },
  { label: 'Course', value: 'course' },
  { label: 'Instructor', value: 'instructor' },
] as const;

export type SearchMode = 'student' | 'course' | 'instructor';
